import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Homepage } from "@/pages/Homepage";
import { TempleDetailPage } from "@/pages/TempleDetailPage";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { AboutUs } from "@/pages/AboutUs";
import { ContactUs } from "@/pages/ContactUs";
import { Toaster } from "@/components/ui/sonner";

const PlannerPage = lazy(() => import("@/pages/PlannerPage"));
const AdminReviewsPage = lazy(() => import("@/pages/AdminReviewsPage"));
const BlogIndexPage = lazy(() => import("@/pages/BlogIndexPage"));
const BlogArticlePage = lazy(() => import("@/pages/BlogArticlePage"));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-4 border-saffron-500 border-t-transparent"></div></div>}>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/temple/:id" element={<TempleDetailPage />} />
              <Route path="/planner" element={<PlannerPage />} />
              <Route path="/admin" element={<AdminReviewsPage />} />
              <Route path="/blog" element={<BlogIndexPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
            </Routes>
          </Suspense>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
